<mat-card-content>
  <div class="item-info-container">
    <div class="itemdetail">
      <div class="item-name"><span>{{'collectionById.editStyleGroup.labelName' | translate}}: {{styleGroupDetails?.styleGroupName}}</span>
      </div>
      <div class="item-desc"><span>{{'collectionById.editStyleGroup.labelDesc' | translate}}: {{styleGroupDetails?.description}}</span></div>
    </div>
    <span class="spacer"></span>
    <div class="edit-btn-wrapper">
      <div class="btn-wrapper">
        <button mat-icon-button aria-label="Add New Item"
          matTooltip="{{'collectionById.editStyleGroup.toolTip.edit' | translate}}" matTooltipPosition="above" (click)="editStyleGroup()" class="edit"><span class="menu-icon">
            <i-feather name="edit"></i-feather>
          </span></button>
      </div>
    </div>
  </div>
  <div class="button-group">
    <button mat-flat-button color="warn" class="btn-warn" (click)='onBack()'>
      <span>{{'questions.btnBack' | translate}}</span>
    </button>
    <div class="btn-right">
      <button mat-flat-button color="" class="btn-warn" aria-label="Style"
      [disabled]="roleSer.accessData?!roleSer.accessData.insertAllowed:true" (click)="openStyleDialog(true, '')">+ {{'collectionById.newStyle.btnNew' | translate}}</button>
    </div>
  </div>

  <div>
    <div class="table-container">
      <table mat-table class="mat-elevation-z8" [dataSource]="dataSource" *ngIf="!noDataFound">
        <ng-container matColumnDef="style">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.newStyle.column1' | translate}}</th>
          <td mat-cell *matCellDef="let row" (click)="openStyleDialog(false, row)">
            <ng-container *ngIf="row?.styleName?.length > 40 then sliceTitle else noSliceTitle">
            </ng-container>

            <ng-template #sliceTitle>
              <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.styleName}}" matTooltipPosition="above">
                {{row?.styleName | slice: 0:40}}...</div>
            </ng-template>
            <ng-template #noSliceTitle>
              <div class="text-bold">{{row?.styleName }}</div>
            </ng-template>

            <ng-container *ngIf="row?.description?.length > 40 then sliceDescription else noSliceDescription">
            </ng-container>
            <ng-template #sliceDescription>
              <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.description}}" matTooltipPosition="above" class="description-text">
                {{row?.description | slice: 0:40}}...</div>
            </ng-template>
            <ng-template #noSliceDescription>
              <div class="description-text">{{row?.description }}</div>
            </ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="Updated">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.newStyle.column2' | translate}}</th>
          <td mat-cell *matCellDef="let row" (click)="openStyleDialog(false, row)"><div class="text-bold">{{row.updatedBy }}</div> {{row.updated | dateAgo}}</td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.newStyle.column3' | translate}}</th>
          <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="deleteStyle(row)"
              matTooltip="{{'collectionById.newStyle.toolTip.delete' | translate}}">
              <mat-icon>delete</mat-icon>
              </button>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu"> -->
              <!-- <button mat-menu-item (click)="openStyleDialog(false, row)">
                <mat-icon>add</mat-icon>
                <span>{{'collectionById.newStyle.toolTip.edit' | translate}}</span>
              </button> -->
              <!-- <button mat-menu-item (click)="deleteStyle(row)">
                <mat-icon>delete</mat-icon>
                <span>{{'collectionById.newStyle.toolTip.delete' | translate}}</span>
              </button> -->
            <!-- </mat-menu> -->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true" ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" >{{row|json}}</tr>
      </table>
      <div class="data-not-found-container" *ngIf="noDataFound">
        <p>{{'collectionById.styleGroups.errorMsg2' | translate}}</p>
      </div>
    </div>
    <div class="style-paginator" *ngIf="styleData.length > 0">
      <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-card-content>

<ng-template #deleteError>
  <mat-dialog-content>
    <div style="text-align: center;">
      <h4>{{deleteErrorMsg}}</h4>
      <br>
      <button mat-flat-button color="" (click)='closeDialog()' mat-raised-button class="okBtn">
        {{'collectionById.styleGroups.confirmPopup.btnOk' | translate}}
      </button>
    </div>
  </mat-dialog-content>
</ng-template>
